<template>
	<row-object-page name="caldav_edit" :oref="oref" v-model="caldav"></row-object-page>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import RowObjectPage from "@/pages/row-object/RowObjectPage.vue";
import {RowObjectRef, RowObjectType, SrcType} from "@t/meta/SourceType.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import type {CalDavSettings} from "@t/event/CalDavSettings.ts";
import {connectEventBus, injectEnv} from "@fd/Environment.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";
import {EDIT} from "@/pages/row-object/RowObjectEvents.ts";

const ns = useNavigationStore();
const env = injectEnv();
const route = useVirtualRoute();
const bus = connectEventBus("CalDavSettingsPage");

const oref = computed<RowObjectType>(() => {
	return <RowObjectRef>{
		type: SrcType.CALDAVSETTINGS,
		id: route.query.id
	};
});

const caldav = ref<CalDavSettings>(null);

function doEdit() {
	ns.forward(env.msg("menu.editCalDav"));
}
bus.on(EDIT, doEdit);
</script>

<style>
	.mono {
		font-family: var(--font-mono);
	}
	
	.sameBaseline {
		line-height: var(--font-size);
		vertical-align: baseline;
		background-color: var(--menu-hi-bg);
		color: var(--menu-hi-fg);
	}
</style>